<template>
  <section class="typeUser">
    <header class="typeUser__header">
      <h2 class="typeUser__title">Configuración inicial de la cuenta</h2>
    </header>

    <div class="typeUser__section">
      <div class="typeUser__sectionHeader">
        <p class="typeUser__label">Tipo de cuenta *</p>
      </div>
      <div class="typeUser__accountCards">
        <AccountTypeCard v-for="option in accountTypes" :key="option.key" :option="option" :active="option.key === 'group' ? isGroupAccount : !isGroupAccount" @select="setAccountType" />
      </div>
      <div v-if="isGroupAccount" class="typeUser__info">
        <iconic name="info" class="typeUser__infoIcon" aria-hidden="true" />
        <p class="typeUser__infoText">Estás creando una cuenta grupal (tipo modelo por defecto). No requiere datos personales.</p>
      </div>
    </div>

    <div class="typeUser__section" v-if="!isGroupAccount">
      <div class="typeUser__sectionHeader">
        <p class="typeUser__label">Tipo de usuario *</p>
      </div>
      <div class="typeUser__contentRoles">
        <li
          class="typeUser__checkbox"
          :class="{ 'typeUser__checkbox--disabled': isGroupAccount && role.key !== 'model' }"
          tabindex="0"
          v-for="role in rolesOptions"
          :key="role.key"
          :aria-label="role.key"
          @keydown.enter="selectRole(role.key)"
        >
          <input class="mycheck" type="radio" name="role" :id="role.key" :value="role.key" v-model="$store.state.user.dataUser.role" :disabled="isGroupAccount && role.key !== 'model'" />
          <label :for="role.key">
            {{ role.name }}
          </label>
        </li>
      </div>
    </div>
  </section>
</template>

<script>
  import AccountTypeCard from "./AccountTypeCard.vue";

  export default {
    components: { AccountTypeCard },
    data() {
      return {
        roles: this.$global.dictionary.roles_es_auto,
        rolesOptions: [],
        accountTypes: [
          { key: "individual", title: "Individual", description: "Individual", icon: "user" },
          { key: "group", title: "Grupal", description: "Cuenta para shows", icon: "group" },
        ],
        lastIndividualRole: this.$store.state.user.dataUser.role || "model",
      };
    },
    computed: {
      user() {
        return this.$store.state.user.dataUser;
      },
      isGroupAccount() {
        const { accountType, role, platformType } = this.user || {};
        if (accountType === "group") return true;
        if (role !== "model") return false;

        const list = Array.isArray(platformType) ? platformType : platformType ? [platformType] : [];
        return list.includes("group");
      },
    },
    methods: {
      setAccountType(type) {
        const isValidType = this.accountTypes.some(({ key }) => key === type);
        if (!isValidType) return;
        this.$store.state.user.dataUser.accountType = type;

        if (type === "group") {
          this.$store.state.user.dataUser.platformType = ["group"];
          this.lastIndividualRole = this.$store.state.user.dataUser.role || this.lastIndividualRole;
          this.selectRole("model");
        } else {
          this.$store.state.user.dataUser.platformType = null;
          this.restoreRoleAfterGroup();
        }
      },
      selectRole(role) {
        if (this.isGroupAccount && role !== "model") return;
        this.$store.state.user.dataUser.role = role;

        if (!this.isGroupAccount) {
          this.lastIndividualRole = role;
        }
      },
      restoreRoleAfterGroup() {
        if (this.lastIndividualRole) {
          this.selectRole(this.lastIndividualRole);
          return;
        }
        this.selectRole("model");
      },
      verifyNext() {
        const { accountType } = this.$store.state.user.dataUser || {};
        const isValid = ["individual", "group"].includes(accountType);

        if (!isValid && this.$toast) {
          this.$toast.error("Selecciona un tipo de cuenta");
        }

        return isValid;
      },
    },
    mounted() {
      this.rolesOptions = Object.entries(this.roles).map(([key, name]) => ({ name, key }));
      if (this.isGroupAccount) {
        this.setAccountType("group");
      } else if (!this.$store.state.user.dataUser.accountType) {
        this.setAccountType("individual");
      }
    },
  };
</script>

<style lang="scss">
  .typeUser {
    @include Flex(column, flex-start, flex-start);
    width: 100%;
    gap: $mpadding;
    &__title {
      color: #3d3d3d;
      font-size: 18px;
      font-weight: 500;
      font-family: $newFont_medium;
      text-transform: none;
    }
    &__subtitle {
      display: none;
    }
    &__header {
      @include Flex(column, flex-start, flex-start);
      gap: 6px;
      width: 100%;
    }
    &__subtitle {
      font-weight: 700;
      font-size: 18px;
    }
    &__section {
      @include Flex(column, flex-start, flex-start);
      gap: 16px;
      width: 100%;
    }
    &__sectionHeader {
      @include Flex(row, space-between, center);
      width: 100%;
      gap: 10px;
    }
    &__label {
      font-family: $newFont_medium;
      color: #3d3d3d;
      font-weight: 500;
      font-size: 16px;
    }
    &__helper {
      display: none;
    }
    &__badge {
      display: none;
    }
    &__accountCards {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      width: 100%;
      gap: 16px;
    }
    &__accountIcon {
      width: 48px;
      height: 48px;
      color: #5c5c5c;
      font-size: 28px;
    }
    &__accountText {
      @include Flex(column, center, center);
      gap: 4px;
      text-align: center;
      width: 100%;
    }
    &__accountName {
      font-weight: 700;
      font-size: 17px;
    }
    &__accountDescription {
      color: #6b6b6b;
      font-size: 13px;
    }
    &__accountSelected {
      position: absolute;
      top: 10px;
      right: 12px;
      font-size: 12px;
      font-weight: 700;
      color: $primary-color;
    }
    &__hint {
      display: none;
    }
    &__errorMsg {
      color: $primary-color;
      font-size: 12px;
      font-weight: 700;
    }
    &__contentRoles {
      display: grid;
      grid-template-columns: repeat(2, minmax(130px, 1fr));
      width: 100%;
      gap: $mpadding / 2;
    }
    &__checkbox {
      @include Flex(row, flex-start);
      width: 100%;
      gap: $mpadding / 2;
      > label {
        font-family: $newFont_regular;
        font-style: 16px;
        cursor: pointer;
        text-transform: capitalize;
        user-select: none;
      }
    }
    &__checkbox--disabled {
      opacity: 0.6;
      cursor: not-allowed;
      label {
        cursor: not-allowed;
      }
    }
    &__info {
      @include Flex(row, flex-start, center);
      gap: 10px;
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #949494;
      border-radius: 10px;
      background: #fafafa;
      color: #4c4c4c;
      border-radius: 12px;
    }
    &__infoIcon {
      color: #8a8a8a;
      font-size: 18px;
    }
    &__infoText {
      font-size: 16px;
      font-family: $newFont_regular;
      color: #949494;
    }
    .mycheck {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      &:checked {
        background-color: $primary-color;
        border-color: $primary-color;
      }
    }
  }
</style>
